import type { MakeCall } from '../createMakeCall';
import {
  LinkListingToBilling,
  PriorityRules,
} from '../types/BillingInformation';

const linkListingToBillingInformation =
  (makeCall: MakeCall) => (data: LinkListingToBilling) =>
    makeCall<PriorityRules>(
      'PUT',
      `/api/v2/billing/billing-info/${data.billingUUID}/priority`,
      {
        data: { rules: [data.rules] },
      },
    );

export { linkListingToBillingInformation };
